import { Box, Button, Grid } from '@mui/material';
import sizeFontCustom from '../Discovery/fontSize.styles';
import { useContext } from 'react';
import StepperContext from '../Context/StepperContext';
import { useTranslation } from '../../hooks/useTranslation';
import { keyboardFocusVisibleSx } from '../../utils/a11y.utils';

function AddNewCard(props) {
	const { t } = useTranslation();
	const { prevStep } = useContext(StepperContext);
	const isActiveFlag = props?.selectedConsentsState?.includes(
		props?.consentHandle,
	)
		? true
		: false;

	const redirect = () => {
		delete global.isTargetedDiscoveryMode;
		global.userClickedAddMore = true;
		global.hasReachedConsent = true;
		global.isAddAccount = true;
		global.fi = global.FIGroups[props.fiType];

		props.history.push(
			`/home/?number=${global.mobileNumber}&isAddAccount=${true}`,
			{
				fiTypes: global.FIGroups[props.fiType],
				wentToFipSelection: true,
			},
		);
	};
	const handleAddAccount = () => {
		if (!isActiveFlag) {
			return;
		}
		redirect();
		prevStep();
	};

	return (
		<Grid
			container
			padding={'1rem'}
			sx={{
				alignItems: 'center',
				borderRadius: '20px',
				border: `1.5px dashed ${!isActiveFlag ? 'lightgray' : props.customDetails?.primaryColor}`,
				textAlign: 'left',
			}}
		>
			<Button
				disabled={!isActiveFlag}
				variant="text"
				onClick={handleAddAccount}
				aria-label={`${t('common.buttons.addNew')} ${props.fiType}`}
				sx={{
					...sizeFontCustom.subHeading,
					p: '0.25rem',
					minWidth: 0,
					backgroundColor: 'transparent',
					color: props?.customDetails?.isDark
						? '#ffffff'
						: props.customDetails?.primaryColor,
					borderRadius: '4px',
					'&:hover': {
						backgroundColor: 'transparent',
					},
					...keyboardFocusVisibleSx,
				}}
			>
				<Box
					aria-hidden
					sx={{
						display: 'inline-flex',
						alignItems: 'center',
						justifyContent: 'center',
						minHeight: 0,
						width: '25px',
						height: '25px',
						mr: '0.5rem',
						borderRadius: '50%',
						backgroundColor: !isActiveFlag
							? 'lightgray'
							: props.customDetails?.primaryColor,
						color: '#fff',
						fontSize: '1rem',
						lineHeight: 1,
						flexShrink: 0,
					}}
				>
					+
				</Box>
				{props.fiType}
			</Button>
		</Grid>
	);
}

export default AddNewCard;
